import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MapsService {
  constructor(
    @Inject('map-key') private key: string
  ) {
    console.log("🚀 ~ MapsService ~ maps:", this.key)
  }

}
